<template>
    <div id="container" class="center full">
        <QuestionBox />
    </div>
</template>

<script>
import QuestionBox from '../components/QuestionBox.vue';

export default {
    name: 'QuizzPage',
    components: {
        QuestionBox
    },
    data() {
        return {

        }
    },
    mounted() {
    }
}
</script>

<style scoped>
.center {
    display: flex;
    justify-content: center;
    align-items: center;
}

#container {
    background-color: rgb(47, 114, 129);
}
</style>
